<script setup>
import FormJopApplication from '../Form/FormJopApplication.vue';

// Components

const props = defineProps({
    title: String,
    text: String,
    vacancy: Object,
});
</script>

<template>
    <div class="bg-gray-lighter" id="jop-application-form">
        <div class="container flex justify-center py-12 md:py-16" v-if="title">
            <div class="md:w-8/12">
                <h2 class="" v-html="title" v-if="title"></h2>
                <div class="flex flex-col items-center">

                    <div v-if="text" v-html="text" class="max-w-full mb-8 prose text-bodyColor marker:text-primary"></div>
                </div>
                <FormJopApplication :vacancy="vacancy" />
            </div>
        </div>
    </div>
</template>
